import { Filters } from "../typescript/interfaces/context";

export const noFiltersApplied = (filters: Filters): boolean =>
  Object.keys(filters).every((section) => filters[section].length === 0);

export const allObjectValuesEmpty = (o: object): boolean => Object.values(o).every((value) => value.length === 0);
